(function () {
  // Months between boxes by toilet count: [light/average, busy]. Ladder 12 → 9 → 6 → 4 → 3 → 2.
  var CADENCE = { 1: [12, 9], 2: [6, 4], 3: [4, 3], 4: [3, 2] };

  function planMonths(name) {
    var n = (name || '').toLowerCase();
    var m = n.match(/(\d+)\s*(month|mo\b)/);
    if (m) return parseInt(m[1], 10);
    m = n.match(/(\d+)\s*week/);
    if (m) return Math.round(parseInt(m[1], 10) / 4.33);
    if (/year|annual/.test(n)) return 12;
    return null;
  }
  function isPrepaid(name) { return /prepa/i.test(name || ''); }

  function init(root) {
    if (root.dataset.pbReady) return;
    root.dataset.pbReady = '1';
    var form = root.querySelector('[data-pb-form]');
    var planInput = root.querySelector('[data-pb-plan]');
    var plans = [];
    root.querySelectorAll('[data-pb-plans] option').forEach(function (o) {
      plans.push({ id: o.value, name: o.textContent, price: o.dataset.price, months: planMonths(o.textContent), prepaid: isPrepaid(o.textContent) });
    });
    var steps = root.querySelectorAll('[data-pb-step]');
    var bars = root.querySelectorAll('[data-pb-bar]');
    var params = new URLSearchParams(window.location.search);
    var q = function (sel) { return root.querySelector(sel); };

    var t = parseInt(params.get('toilets'), 10);
    if (t) {
      var tr = q('input[name=pb_toilets][value="' + Math.min(4, Math.max(1, t)) + '"]');
      if (tr) tr.checked = true;
    }
    var u = (params.get('usage') || '').toLowerCase();
    var ur = u && q('input[name=pb_usage][value="' + u + '"]');
    if (ur) ur.checked = true;

    function val(name, fb) { var el = q('input[name=' + name + ']:checked'); return el ? el.value : fb; }

    function go(n) {
      steps.forEach(function (s) { s.hidden = s.dataset.pbStep !== String(n); });
      bars.forEach(function (b, i) { b.classList.toggle('is-on', i < n); });
      if (n === 3) result();
      var h = q('[data-pb-step="' + n + '"] [data-pb-focus]');
      if (h && root.dataset.pbStarted) h.focus({ preventScroll: true });
      root.dataset.pbStarted = '1';
    }

    function closest(target, prepaid) {
      var best = null, diff = Infinity;
      plans.forEach(function (p) {
        if (p.prepaid !== prepaid || p.months === null) return;
        var d = Math.abs(p.months - target);
        if (d < diff) { best = p; diff = d; }
      });
      return best;
    }

    var chosen = null, prepaidPlan = null;
    function result() {
      var toilets = parseInt(val('pb_toilets', '2'), 10);
      var usage = val('pb_usage', 'average');
      var months = CADENCE[toilets][usage === 'busy' ? 1 : 0];
      chosen = closest(months, false);
      prepaidPlan = closest(months, true);
      if (chosen && chosen.months) months = chosen.months;
      var unit = months === 1 ? 'month' : 'months';
      var tl = toilets === 4 ? '4+ toilets' : toilets + (toilets === 1 ? ' toilet' : ' toilets');
      var use = usage === 'busy' ? 'busy bathrooms' : usage === 'light' ? 'light use' : 'average use';
      var set = function (sel, txt) { var el = q(sel); if (el) el.textContent = txt; };
      set('[data-pb-months]', months + ' ' + unit + '.');
      set('[data-pb-summary]', tl + ', ' + use + '. We ship a fresh 20 pack every ' + months + ' ' + unit + ', so every tank is covered.');
      set('[data-pb-ships]', months + ' ' + unit);
      var per = Math.round((12 / months) * 10) / 10;
      set('[data-pb-peryear]', String(per));
      if (chosen && chosen.price) set('[data-pb-price]', chosen.price);
      var pre = q('[data-pb-prepay]');
      if (pre) pre.hidden = !prepaidPlan;
    }

    function submit(plan) {
      if (!form) return;
      if (planInput) { planInput.value = plan ? plan.id : ''; planInput.disabled = !plan; }
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    }

    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pb-go]');
      if (a) { e.preventDefault(); go(parseInt(a.dataset.pbGo, 10)); return; }
      if (e.target.closest('[data-pb-start]')) { e.preventDefault(); submit(chosen); return; }
      if (e.target.closest('[data-pb-prepay]')) { e.preventDefault(); submit(prepaidPlan); return; }
      if (e.target.closest('[data-pb-once]')) { e.preventDefault(); submit(null); }
    });

    go(t && root.dataset.skipKnown === 'true' ? 2 : 1);
  }

  function initSticky() {
    var bar = document.querySelector('[data-pb-sticky]');
    var box = document.getElementById('pb-buy');
    if (!bar || !box || !('IntersectionObserver' in window)) return;
    var visible = false;
    function update() {
      var show = !visible && window.scrollY > 500;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var a = bar.querySelector('a');
      if (a) a.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; update(); }).observe(box);
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function boot() { document.querySelectorAll('[data-pb-builder]').forEach(init); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();